import React from 'react'
import { Modal } from 'react-bootstrap'
import InviteContacts from '../../modules/user-management/users-list/user-edit-modal/InviteContacts'
import { useDispatch } from 'react-redux'
import { setContactDetailSlice } from '../../store/slice/contact-detail-slice'
import { InviteContactsProps } from '../../models/Contacts'
import { useTheme } from '../../context/ThemeContext'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const AddNewContactModal: React.FC<InviteContactsProps> = ({
  handleClose, show, getOtherContactHandler, formValues, setFormValues
}: any) => {

  const dispatch = useDispatch()
  const {theme} = useTheme()
  return (
    <Modal 
    contentClassName={theme === 'dark' ? 'theme__div' : ''}
    show={show} onHide={() => {
      handleClose()
      
      setFormValues({})
      dispatch(setContactDetailSlice({ currentDetails: {} }))

    }} size='xl'>

      <Modal.Header>

        <Modal.Title className={`text-truncate ${theme === 'dark' ? 'white__text' : ''}`}>Add New Contact</Modal.Title>
        <i className={`bi bi-x-lg modal-icon-custom ${theme === 'dark' && 'close'}`}  onClick={handleClose}></i>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '650px', overflow: 'auto' }}>
        <InviteContacts buttonTitle={"Add contact"} handleClose={handleClose} inviteFlag={false} getOtherContactHandler={getOtherContactHandler} setFormValues={setFormValues} formValues={formValues} />

      </Modal.Body>
     
    </Modal>
  )
}

export default AddNewContactModal